<script setup lang="ts">
import FooterItem from '@fondof-ui/components/footer/FooterItem.vue'
import FooterList from '@fondof-ui/components/footer/FooterList.vue'
import FooterHeadline from '@satch-ui/components/footer/FooterHeadline.vue'
import type { FooterNavigationItem } from '@satch-ui/components/footer/types'

const props = defineProps<FooterNavigationItem>()
</script>
<template>
  <div
    :data-cfid="props.id"
    class="row-start-1 md:col-start-[first-col] md:row-start-[first-row]"
  >
    <FooterItem>
      <template #headline="{ disabled }">
        <FooterHeadline
          :headline="props.label"
          :disabled="disabled"
          variant="primary"
        />
      </template>
      <template #content>
        <FooterList
          :colors="{ primary: 'text-primary' }"
          color="primary"
          :items="props.items"
        />
      </template>
    </FooterItem>
  </div>
</template>
